'use client';
import { useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

import { routes } from '~constants/routes';
import { useRouter } from '~i18n/navigation';
import { NextUrlConstructor } from '~utils/NextUrlConstructor';

import { promoEventConfig } from '../config';

export const usePromoCallToAction = () => {
	const searchParams = useSearchParams();
	const router = useRouter();

	return useCallback(() => {
		const query = new NextUrlConstructor(
			routes.chats.dialog(promoEventConfig.offersSpecialMembership.botId),
			searchParams
		);
		query
			.delete('gender')
			.delete('desire')
			.delete('maxAge')
			.delete('minAge')
			.delete('keyword')
			.delete('createdBy');
		router.replace(query.getUrl());
	}, [router, searchParams]);
};
